import PriceTag from 'components/priceTag/PriceTag';
import { Currency } from 'models/Currency';
import { Lead } from 'models/Leads';
import { Transaction, TransactionStatus } from 'models/Transactions';

type TransactionAmountRendererProps = {
  transaction: Pick<Transaction, 'amount' | 'status'>;
} & ({ lead: Lead } | { currency: Currency });

const TransactionAmountRenderer = ({
  transaction,
  ...props
}: TransactionAmountRendererProps) => {
  const { amount, status } = transaction;

  const currency =
    'lead' in props ? props.lead.order?.currency : props.currency;

  return (
    <PriceTag
      currency={currency ?? ''}
      currencyFormattingOptions={{
        round: false,
        removeDecimals: amount % Math.floor(amount) === 0,
      }}
      data-testid="amount"
      hasError={status === TransactionStatus.FAILURE}
      value={amount}
    />
  );
};

export default TransactionAmountRenderer;
